import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const savedAuth = sessionStorage.getItem('isAuthenticated');
     /* console.log('AuthProvider initialized. Saved auth:', savedAuth); */  
    return savedAuth === 'true'; 
  });
  const navigate = useNavigate();

  useEffect(() => {
     /* console.log('AuthProvider mounted. Current auth state:', isAuthenticated);  */
  }, [isAuthenticated]);

  const login = () => {
    sessionStorage.setItem('isAuthenticated', 'true');
    setIsAuthenticated(true);
   /*  console.log('User logged in. Auth state:', true);  */
  };

  const edit_profile = () => {
    if (!isAuthenticated) {
      // If not authenticated, redirect to login or another appropriate page
      navigate('/login');
    } else {
      // If authenticated, perform the action and navigate
      /* console.log('User logged in. Auth state:', true); */ 
      navigate('/edit-detail');
    }
  };

  const logout = () => {
    sessionStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
     /* console.log('User logged out. Auth state:', false);  */
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, edit_profile, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
